import * as React from 'react';

import { constantFormat } from '../../../../helpers/constants';
import { ProgressBar } from '../../../../components/synced/ui/ProgressBar/ProgressBar';
import { ProjectDocFolderTreeNode } from '../../models/ProjectDocFolderTreeNode';
import { useIsMobile } from '../../../../helpers/hooks/useIsMobile';
import { ProjectDocFolderStatuses } from '../../../../helpers/mapping/ProjectDocFolderStatuses';
import { DocumentTypeVals } from '../../../../helpers/mapping/DocumentTypeVals';

interface NodeInfoBarProps {
    node: ProjectDocFolderTreeNode;
}

export const NodeInfoBar: React.FC<NodeInfoBarProps> = ({ node }) => {
    const isMobile = useIsMobile(900);
    const data = (node as ProjectDocFolderTreeNode).data;
    const dateValue = data.ContractDate ?? data.DocumentDate;
    const dateRenderValue: string = dateValue
        ? constantFormat.DateToString(constantFormat.StringToDate(dateValue as string))
        : '';
    const dateEndValue = data.DocumentDateEnd;
    const dateEndRenderValue: string = dateEndValue
        ? constantFormat.DateToString(constantFormat.StringToDate(dateEndValue as string))
        : '';
    const dateDisplay = dateEndRenderValue ? `${dateRenderValue} - ${dateEndRenderValue}` : dateRenderValue;
    const percentage: number = data.CompletionPercentage ?? 0;

    const isOrder =
        data.StatusId === ProjectDocFolderStatuses.OrderDocument ||
        data.DocumentTypeId === DocumentTypeVals.ResponsiblePersonOrder;

    if (isMobile) {
        return isOrder ? (
            <>
                {dateDisplay && (
                    <span className="date-info-tree" style={{ flex: 'none' }}>
                        {dateDisplay}
                    </span>
                )}
            </>
        ) : (
            <span
                className="date-info-tree"
                style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600, flex: 'none' }}
            >
                {Math.round(percentage)}%
            </span>
        );
    }

    return (
        <div
            className="node-info-bar"
            style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 'none' }}
            title={
                isOrder ? undefined : dateDisplay ? `Процент согласования и срок по договору` : `Процент согласования`
            }
        >
            {!isOrder && <ProgressBar percent={percentage} width={54} showLabel />}
            {dateDisplay && <span className="date-info-tree">{dateDisplay}</span>}
        </div>
    );
};
